import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export type FormUser = {
  name: string;
  phone: string;
  customRole?: string;
};

export const useUserForm = () => {
  const { t } = useTranslation();
  const validationUserSchema = Yup.object().shape({
    name: Yup.string().required(t('Member_Group_Bulk_Create_22')),
    phone: Yup.string().matches(/^[\d\s-]+$/, {
      message: t('Subscrib_Detail_License_11'),
      excludeEmptyString: true,
    }),
  });
  const userFormOptions: UseFormProps<FormUser> = {
    resolver: yupResolver(validationUserSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<FormUser>(userFormOptions);
};
